
import { defineComponent, ref, watch, onMounted } from "vue";
import { ApiBase } from "@/core/api";
import { useI18n } from "vue-i18n";

interface Props {
  checkStrictly: boolean;
  emitPath: boolean;
  multiple: boolean;
  value: string;
  label: string;
  children: string;
}

interface Categories {
  id: number;
  name: string;
  code: number;
  status: number;
  category_items: Array<any>;
  parent_id: number;
}

export default defineComponent({
  name: "mb-cascader",
  props: {
    label: { type: String, default: "", required: true },
    shortKey: { type: String, default: "" },
    modelValue: { type: String, default: "" },
    optionSource: { type: String, default: "" },
    optionSourceType: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const { t, te } = useI18n();
    const propsData = ref<Props>({
      checkStrictly: false,
      emitPath: false,
      multiple: false,
      value: "id",
      label: "name",
      children: "category_items",
    });
    const options = ref<Categories[]>([]);
    const selectVal = ref(props.modelValue);

    watch(
      () => props.modelValue,
      (newVal) => {
        selectVal.value = newVal;
      }
    );

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const getCategoriesOptions = async (keywork: string) => {
      const { data } = await ApiBase.getCategorySourceData({
        code: keywork,
      });
      if (data.code == 0) {
        options.value.splice(0, options.value.length, ...data.data);
      }
    };

    const handleChange = (value) => {
      selectVal.value = value;
      context.emit("update:modelValue", value);
    };

    onMounted(() => {
      if (props.optionSourceType == "remote") {
        if (props.optionSource == "pim_category") {
          getCategoriesOptions("Categories");
        } else if (props.optionSource == "pim_crowd") {
          getCategoriesOptions("crowd");
        }
      }
    });

    return {
      translate,
      propsData,
      options,
      selectVal,
      handleChange,
    };
  },
});
